import type { GetEmployees } from "../types/services";
import { instanceEmployee } from "../../../../services/instances";
import type { Employee } from "../types/services";

const getEmployees = async ({
  params,
  alert,
}: GetEmployees): Promise<{ employees: Employee[] }> => {
  const { showAlert, t } = alert;

  let employees: Employee[] = [];

  await instanceEmployee
    .get("/employee", { params })
    .then((response) => {
      employees = response.data.data;
    })
    .catch(() => {
      showAlert("error", t("alerts.error_get_employees"));
    });

  return {
    employees,
  };
};

export { getEmployees };
